module.exports = __webpack_public_path__ + "img/help20.9aae75d9.png";